module.exports = __webpack_public_path__ + "static/media/starry-night.17f1ac3c.jpg";